import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { usePlayer } from '../../hooks/PlayerProvider';
import { useIcons } from '../../hooks/useIcons';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { IconButton, IconButtonProps } from '../IconButton/IconButton';

export const PauseButton: FunctionComponent<IconButtonProps> = ({
  size,
  ...props
}) => {
  const player = usePlayer();
  const { Pause } = useIcons();

  const pause = useCallback(
    (e: MouseEvent | KeyboardEvent) => {
      // The pause plugin requires a `pauseReason` to be set to `interaction` in order to function properly,
      // in addition we need to use `playToggle` method as the `pause` doesn't support `meta` parameter.
      // Plugin reference https://github.schibsted.io/svp/web-player/blob/master/src/js/player/plugins/pause.js#L87
      e.stopPropagation();
      const jw = player.getJWPlayer();
      jw?.playToggle({ reason: 'interaction' });
    },
    [player]
  );

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === 'Space' || e.code === 'KeyK') {
        pause(e);
      }
    },
    [pause]
  );

  useKeyboardHandler(handleKeydown);

  return (
    <IconButton onClick={pause} size={size} {...props}>
      <Pause />
    </IconButton>
  );
};
